import { useEffect } from "react"
import { useCallback } from "react"
import { useContext } from "react"
import { useState } from "react"
import { MdContentCopy, MdDelete } from "react-icons/md"
import UserContext from "../../Context/UserContext"
import { checkInviteWhereMail, checkStaffInviteWhereMailAndEvent, createStaffInvite, deleteInviteDoc, getEventDoc, getStaffPendingInviteWhereExhibitor } from "../../Requests/firebaseFirestore"
import { sendStaffInvite } from "../../Requests/sendMail"
import Modal from "../Modal"

export default function StaffAsExhibitor() {
  const [newStaff, setNewStaff] = useState({})
  const [events, setEvents] = useState([])
  const [sending, setSending] = useState(false)
  const [message, setMessage] = useState('')
  const [alert, setAlert] = useState('')
  const {user, seeAs, url} = useContext(UserContext)
  const [invitesModal, setInvitesModal] = useState(false)
  const [invites, setInvites] = useState([])

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
  }

  const handleInvitesModal = async () => {
    if(!invitesModal){
      let invts
      if(seeAs){
        invts = await getStaffPendingInviteWhereExhibitor({id:seeAs.id, fullName:seeAs.fullName})
      }else{
        invts = await getStaffPendingInviteWhereExhibitor({id:user.uid, fullName:user.fullName})
      }
      setInvites([...invts])
    }
    setInvitesModal(!invitesModal)
  }

  const handleInput = (e) =>  {
    const {name, value} = e.target
    setAlert('')
    setMessage('')
    setNewStaff({...newStaff, [name]:value})
  }

  const getInfo = useCallback(async()=>{
    if(seeAs){
      setEvents([...seeAs.events])
    }else{
      setEvents([...user.events])
    }
  },[user, seeAs])

  useEffect(()=>{
    getInfo()
  },[])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSending(true)
    let sender = {}
    if(seeAs){
      sender = {fullName:seeAs.fullName, id:seeAs.id, company:seeAs.company}
    }else{
      sender = {fullName:user.fullName, id:user.uid, company:user.company}
    }


    const staffInfo = {...newStaff, event:events[newStaff.event], sender:{id:sender.id, fullName:sender.fullName}, company:sender.company}
    
    const check = await checkStaffInviteWhereMailAndEvent(newStaff.email, staffInfo.event.id)

    if(check){
      setAlert('Ya se ha enviado una invitación')
    }else{
      setAlert('')
      const res = await createStaffInvite(staffInfo)
      if(res.status==='success'){
        const event = await getEventDoc(staffInfo.event.id)
        const send = await sendStaffInvite({inviteId:res.docRef.id, email:newStaff.email, event:event, company:sender.company, fullName:sender.fullName})
        if(send.status==='success'){
          setMessage('Invitación enviada')
          setNewStaff({})
        }else{
          await deleteInviteDoc(res.docRef.id)
          setAlert('No se ha podido enviar la invitación')
        }
      }else{
        setAlert('No se ha podido enviar la invitación')
      }
    }

    setSending(false)
  }

  const handleDeleteInvite = async (inviteId) => {
    await deleteInviteDoc(inviteId)
    handleInvitesModal()
  }

  return   <>
  <div className="w-1/2 max-w-[500px] min-w-[300px] mx-auto">
    <div className="flex sm:justify-start justify-center mt-4">
      <button className="action-btn mx-auto" onClick={handleInvitesModal}>Invitaciones pendientes</button>
    </div>
    <div className="border border-stone-400 mt-5 mx-auto rounded-[10px] py-4 px-6 flex flex-col justify-center gap-4">
    <h1 className="text-xl text-center flex mx-auto">Nuevo miembro de staff</h1>
    <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
      <div className="input-holder w-[75%]">
        <input type="text" id="new-staff-name" name='name' onChange={handleInput} value={newStaff.name||''} required/>
        <label htmlFor="new-staff-name">Nombre</label>
      </div>
      <div className="input-holder w-[75%]">
        <input type="email" id="new-staff-email" name="email" onChange={handleInput} value={newStaff.email||''} required />
        <label htmlFor="new-staff-email">Email</label>
      </div>
      <div className="input-holder w-[75%]">
        <select name="event" id="new-staff-event" onChange={handleInput} value={newStaff.event || ''} required>
          <option value="" hidden disabled></option>
          {events.map((event, index)=>{return(
            <option value={index} key={index}>{event.name}</option>
            )})}
        </select>
        <label htmlFor="new-staff-event">Evento</label>
      </div>
      {alert===''?<></>:
        <span className="text-red-500 text-center">{alert}</span>
      }
      {message === '' ?<></>:
        <span className="block mx-auto text-center">{message}</span>
      }
      <button className="send-btn" disabled={sending}>{sending?'Enviando...':'Invitar'}</button>
    </form>
    </div>
      </div>
      <Modal isActive={invitesModal} handle={handleInvitesModal} title='Invitaciones pendientes' size={'lg'}>
        <div className="w-[90%] mx-auto">
        {
          invites.length===0?
          <h1 className="font-semibold text-xl text-center my-[50px]">No se encontraron invitaciones.</h1>:<>
          <div className="table-holder">
            <table className="w-full min-w-[500px]">
              <thead>
                <tr className="bg-[#F03623] text-white font-semibold">
                  <th>Acción</th>
                  <th>Enviado a</th>
                  <th>Evento</th>
                </tr>
              </thead>
              <tbody>
                {invites.map((invite, index)=>{return(
                  <tr key={index}>
                    <td><div className="flex gap-1">
                      <button className="action-button border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleDeleteInvite(invite.id)}}><MdDelete size={25}/></button>
                    <button className="action-button border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500 active:bg-blue-700 duration-150" onClick={()=>{handleCopy(`${url}/newuser/staff/${invite.id}`)}}><MdContentCopy size={25}/></button>
                    </div></td>
                    <td>{invite.email}</td>
                    <td>{invite.event.name}</td>
                  </tr>
                )})}
              </tbody>
            </table>
           </div>
          </>
        }
        </div>
      </Modal>
    </>
}